export default __webpack_public_path__ + "static/media/pro-elevate-gry-1.1a4c8926.png";